import { type AdminCardApiModel } from '@webapp/modules/spending-cards/data-access/api-models/AdminCardApiModel'
import { type AdminCardConstructor } from '@webapp/modules/spending-cards/entities/AdminCard'

const mapCardShippingAddress = (
  addressData: AdminCardApiModel['shipping_address']
) => {
  if (
    !addressData?.address_line_one ||
    !addressData?.postal_code ||
    !addressData?.city ||
    !addressData?.country
  ) {
    return null
  }

  return {
    addressLine1: addressData.address_line_one,
    addressLine2: addressData.address_line_two,
    postalCode: addressData.postal_code,
    city: addressData.city,
    stateProvince: addressData.state_province,
    country: addressData.country,
  }
}

export const mapAdminCardApiModel = (
  card: AdminCardApiModel
): AdminCardConstructor => ({
  id: card.id,
  externalId: card.external_id,
  last4Digits: card.number,
  type: card.category,
  provider: card.cardholder.provider,
  status: card.status,
  cardholder: {
    id: card.cardholder.id,
    userId: card.cardholder.user_id,
    firstName: card.cardholder.first_name,
    lastName: card.cardholder.last_name,
    email: card.cardholder.email,
    profileImage: card.cardholder.profile_image,
    secondaryCategoryId: card.cardholder.department_id,
  },
  createdAt: card.created_at,
  updatedAt: card.updated_at,
  requireActivation: card.require_activation,
  balance: Number(card.balance),
  currencyName: card.currency,
  shippingAddress: mapCardShippingAddress(card.shipping_address),
})
